import { batch } from 'react-redux';
import { 
  fetchCreateGhostVariant,
  fetchSingleGhostsByID,
  fetchCreateModel,
  fetchCreateProject,
  fetchCreateLoadout,
  fetchUpdateStoreFields
} from '../../utils/fetchData';
import { fetchOnboardingUser } from '../../utils/fetchDataGraphQL';
import { 
  getStoreSuccess,
  getUserSuccess,
} from '../slices/account';
import { getJWTstorage } from '../../utils/jwt'
import { generateUUID } from '../../utils/levarHelpers'
import { copyS3Files } from '../../S3Config/s3Integration';

// **************************************************************************
// Create Sample Project/Loadout/Ghost/Model/Subscription(FREE) on SignUp 2025
// **************************************************************************
export function setCreateOnboardingInformation() {
  return async (dispatch, getState) => {
    try {
      const { account: { store, integration, user }, admin } = getState();
      const jwt = getJWTstorage(admin, user.uuid);
      
      const storeID = store.store_id;
      const storeTitle = store.store_title;
      const levarAccountID = integration.levar_account_id;
      const userEmail = user.email;
      const userFirstName = user.first_name;
      const userLastName = user.last_name;
      
      // ****************************************************
      // 1. Create Projectwhat 
      const projectInfo = {
        store_title: storeTitle,
        store_id: storeID,
        levar_user_account_id: levarAccountID,
        project_title: `${storeTitle}'s Self Service Project`,
        project_description: 'Self Service Porject',
        contact_name: `${userFirstName} ${userLastName}`,
        contact_email: `${userEmail}`,
        project_type: 'upload',
        self_service: true
      };

      const selfServiceProject = await fetchCreateProject(projectInfo, jwt);

      // 2. Create Loadout
      const loadoutPayload = {
        project_id: selfServiceProject._id,
        store_id: storeID,
        store_title: storeTitle,
        loadout_wizard_stage: 2, // Loadout Product Selector
        client_loadout_stage: 7, // Finalized
        loadout_type: 1, // Ecom Type
        loadout_title: `${storeTitle} Self Service Loadout`,
        product_details: '',
        additional_product_photos: '',
        linked_products: [],
        artist_name: 'self_service',
        self_service: true
      };

      const selfServiceLoadout = await fetchCreateLoadout(loadoutPayload, jwt);

      // ****************************************************
      // Create Sample Model
      const headphonesGhostID = "890154a6-cde1-4d17-9d25-ffee0f83de6f"; // Headphones TAV HAS USDZ
      // const headphonesGhostID = "6b12369b-f539-4c56-9b1b-173c085e4817"; // Headphones Black Missing USDZ
      // const headphonesGhostID = "e4c5354e-ad81-4e06-b37d-de17cb65fd93"; // Lights

      // 3. Get Original GHOST Model and 
      const ghostResponse = await fetchSingleGhostsByID(headphonesGhostID, jwt);
      const ogGhostPayload = ghostResponse.ghost_search_response_hits_source[headphonesGhostID];
      delete ogGhostPayload.ghost_variant_id
      delete ogGhostPayload.model_3d_id
      delete ogGhostPayload.model_3d_id_updated_at
      delete ogGhostPayload.updated_at
      delete ogGhostPayload.created_at

      // console.log("OG GHOST", ogGhostPayload);

      const bundleUUID = generateUUID();

      const newGhostPayload = {
        ...ogGhostPayload,
        ghost_title: `Sample Model`,
        ghost_client_title: `Sample Model`,
        ghost_stage: 4,
        store_id: storeID,
        loadout_id: selfServiceLoadout._id,
        bundle: bundleUUID
      };
      // console.log("NEW GHOST", newGhostPayload)

      // 4. then call Create New Ghost with new payload
      const createdGhost = await fetchCreateGhostVariant(newGhostPayload, jwt);

      // 5. Copy S3 contents from og bundle folder to new bundle folder
      const ogGhostFolder = `ghosts/${ogGhostPayload.store_id}/${ogGhostPayload.bundle}`;
      const newModelFolder = `models/${store.store_id}/${bundleUUID}`;
      
      // Copy Ghost => Model
      await copyS3Files(ogGhostFolder, newModelFolder, 'ghost-model', false);

      // 6. Create Model Document
      const modelPayload = {        
        ghost_variant_id: createdGhost._id,
        model_status: "on",
      }

      // 7. Create Model
      const createdModel = await fetchCreateModel(modelPayload, jwt);
      // console.log("createdModel", createdModel)

      // 8. Update User Setup Wizard State === 8
      const onboardingUser = await fetchOnboardingUser(store.store_url, '');

      // 9. Update Store Billing and Model Limit
      // integrationID 1,2,3 shopfiy, custom, bigcommerce
      const shopifyBillingPayload = {
        shopify_billing_status: "free",
        fixed_price: 0,
        model_limit: 2
      }

      const stripeBillingPayload = {
        stripe_billing_status: "free",
        fixed_price: 0,
        model_limit: 2
      }

      const payload = {
        // Always include store_id except for BigCommerce (id=3) where we use both store_id and store_hash
        store_id: store.store_id,
        // Add store_hash only for BigCommerce (integration_id=3)
        ...(integration.integration_id === 3 && { store_hash: `bco_${store.store_hash}` }),
        // Add shopify billing for Shopify (integration_id=1)
        ...(integration.integration_id === 1 && shopifyBillingPayload),
        // Add stripe billing for Custom or BigCommerce (integration_id=2 or 3)
        ...((integration.integration_id === 2 || integration.integration_id === 3) && stripeBillingPayload)
      };

      console.log("PAYLOAD", payload)

      const updatedStore = await fetchUpdateStoreFields(payload, jwt, admin.adminStatus);
      // console.log("updatedStore", updatedStore)

      batch(() => {
        dispatch(getStoreSuccess(updatedStore._source));
        dispatch(getUserSuccess(onboardingUser.levarUser));
      })

      return { 
        success: true
      };

    } catch(error) {
      console.log('error on  thunk', error);
      return error;
    }
  }
};

// Create sample project and loadout with models in review stage (ADMIN CREATED)
export function setCreateSampleReviewProject({ storeDetails, userDetails }) {
  return async (dispatch, getState) => {
    try {
      const { account: { user }, admin } = getState();
      

      // eslint-disable-next-line camelcase
      const { store_title: storeTitle, store_id: storeID, levar_user_account_id: levarAccountID } = storeDetails;
      const { email: userEmail } = userDetails;
      const jwt = getJWTstorage(admin, user.uuid);

      console.log('userDetails', userDetails)
      // ****************************************************
      // 1. Create Project
      const projectInfo = {
        store_title: storeTitle,
        store_id: storeID,
        levar_user_account_id: levarAccountID,
        project_title: `${storeTitle}'s ADMIN CREATED`,
        project_description: 'AUTO Project',
        contact_name: `AUTO Create`,
        contact_email: `${userEmail}`,
        project_type: 'create',
        project_stage: 1,
        project_status: "in-progress",
        self_service: true
      };

      const selfServiceProject = await fetchCreateProject(projectInfo, jwt);

      // 2. Create Loadout
      const loadoutPayload = {
        project_id: selfServiceProject._id,
        store_id: storeID,
        store_title: storeTitle,
        loadout_wizard_stage: 2, // Loadout Product Selector
        client_loadout_stage: 7, // Finalized
        loadout_type: 1, // Ecom Type
        loadout_title: `${storeTitle} Self Service Loadout`,
        product_details: '',
        additional_product_photos: '',
        linked_products: [],
        artist_name: 'self_service',
        self_service: true
      };

      const selfServiceLoadout = await fetchCreateLoadout(loadoutPayload, jwt);

      return {
        success: true,
        message: 'Sample review project created successfully'
      };

    } catch (error) {
      console.error('Error creating sample review project:', error);
      throw error;
    }
  };
}
